import React from 'react'
import { DataTable, type DataTableColumn } from '@enamelai/design-system'
import { BillingTabType } from '@components/pages/Billing/useBilling'
import './BillingSkeleton.css'

const LEDGER_COLUMNS: DataTableColumn[] = [
  { id: 'patientName', label: 'Patient' },
  { id: 'invoiceNumber', label: 'Invoice no.' },
  { id: 'providerName', label: 'Provider name' },
  { id: 'appointmentDate', label: 'Appt. date' },
  { id: 'approvedInsurance', label: 'Approved ins.' },
  { id: 'patientResponsibility', label: 'Patient resp.' },
  { id: 'appointmentBalance', label: 'Appointment balance' },
]

const INVOICE_COLUMNS: DataTableColumn[] = [
  { id: 'invoiceNo', label: 'Invoice no.' },
  { id: 'invoiceDate', label: 'Invoice date' },
  { id: 'patientName', label: 'Patient name' },
  { id: 'charges', label: 'Charges' },
  { id: 'approvedInsurance', label: 'Approved ins.' },
  { id: 'discount', label: 'Discount' },
  { id: 'appointmentAdjustment', label: 'Appointment adj.' },
  { id: 'patientResponsibility', label: 'Patient resp.' },
  { id: 'status', label: 'Status' },
]

const OUTSTANDING_PAYMENT_COLUMNS: DataTableColumn[] = [
  { id: 'invoiceNo', label: 'Invoice no.' },
  { id: 'invoiceDate', label: 'Invoice date' },
  { id: 'patientName', label: 'Patient name' },
  { id: 'patientResponsibilityBalance', label: 'Amount due' },
]

const PAYMENT_HISTORY_COLUMNS: DataTableColumn[] = [
  { id: 'invoiceId', label: 'Invoice no.' },
  { id: 'paymentDate', label: 'Payment date' },
  { id: 'amountDue', label: 'Amount due' },
  { id: 'method', label: 'Method' },
  { id: 'amountPaid', label: 'Amount paid' },
  { id: 'paidBy', label: 'Paid by' },
]

const TRANSACTION_COLUMNS: DataTableColumn[] = [
  { id: 'date', label: 'Date' },
  { id: 'patient', label: 'Patient' },
  { id: 'type', label: 'Type' },
  { id: 'description', label: 'Description' },
  { id: 'tooth_details', label: 'T/S' },
  { id: 'charges', label: 'Charges' },
  { id: 'amount', label: 'Amount' },
  { id: 'insurance_adjustment', label: 'Insurance adj.' },
  { id: 'patient_adjustment', label: 'Patient adj.' },
  { id: 'balance', label: 'Balance' },
]

interface BillingSkeletonProps {
  variant?: BillingTabType
}

const BillingSkeleton: React.FC<BillingSkeletonProps> = ({
  variant = BillingTabType.Ledger,
}) => {
  if (variant === BillingTabType.Payments) {
    return (
      <div className="billing-skeleton" aria-hidden="true">
        <DataTable
          columns={OUTSTANDING_PAYMENT_COLUMNS}
          rows={[]}
          state="loading"
          showActions
          actionsLabel="Actions"
        />
        <DataTable
          columns={PAYMENT_HISTORY_COLUMNS}
          rows={[]}
          state="loading"
          showActions
          actionsLabel="Notes"
        />
      </div>
    )
  }

  return (
    <div className="billing-skeleton" aria-hidden="true">
      <DataTable
        columns={
          variant === BillingTabType.Invoices
            ? INVOICE_COLUMNS
            : variant === BillingTabType.Transactions
              ? TRANSACTION_COLUMNS
              : LEDGER_COLUMNS
        }
        rows={[]}
        state="loading"
        showActions
        actionsLabel="Actions"
      />
    </div>
  )
}

export default BillingSkeleton
